import React from 'react';

const WEDDING_DATE = new Date('2026-08-14T12:00:00').getTime();

function calcDiff() {
    const diff = WEDDING_DATE - Date.now();
    if (diff <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
    };
}

const Countdown: React.FC = () => {
    const now = new Date();
    const isPast = WEDDING_DATE - now.getTime() <= 0;

    const [countdown, setCountdown] = React.useState(calcDiff);

    React.useEffect(() => {
        const timer = setInterval(() => {
            const result = calcDiff();
            setCountdown(result);
            if (result.days === 0 && result.hours === 0 && result.minutes === 0 && result.seconds === 0) {
                clearInterval(timer);
            }
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const items = [
        { label: 'Дней', value: countdown.days },
        { label: 'Часов', value: countdown.hours },
        { label: 'Минут', value: countdown.minutes },
        { label: 'Секунд', value: countdown.seconds },
    ];

    return (
        <section className="bg-cream py-20 md:py-28 relative">
            <div className="max-w-3xl mx-auto px-4">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-gold mb-4">
                    {isPast ? '' : 'отсчёт времени'}
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-12">
                    {isPast ? 'Свадьба состоялась!' : 'До свадьбы осталось'}
                </h2>
                {!isPast && (
                    <div className="flex justify-center gap-3 md:gap-6">
                        {items.map((item, i) => (
                            <React.Fragment key={item.label}>
                                <div className="countdown-box rounded-2xl px-4 py-5 md:px-8 md:py-7 flex flex-col items-center min-w-[60px] md:min-w-[100px]">
                                    <span className="font-serif text-3xl md:text-5xl font-semibold text-prussian_blue leading-none">
                                        {String(item.value).padStart(2, '0')}
                                    </span>
                                    <span className="font-sans text-[10px] md:text-xs uppercase tracking-[0.15em] text-warm_gray mt-2.5">
                                        {item.label}
                                    </span>
                                </div>
                                {i < items.length - 1 && (
                                    <span className="text-gold/40 font-light text-2xl md:text-4xl self-center">:</span>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Countdown;

